import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import { ConfigProvider } from 'antd'
import zhCN from 'antd/es/locale/zh_CN'
import enUS from 'antd/es/locale/en_US'
import './i18n/config'
import { useTranslation } from 'react-i18next'

const AppWrapper = () => {
  const { i18n } = useTranslation()
  const antdLocale = i18n.language === 'zh' ? zhCN : enUS

  return (
    <ConfigProvider
      locale={antdLocale}
      theme={{
        token: {
          colorPrimary: '#0066cc',
          borderRadius: 8,
          fontFamily: i18n.language === 'zh' 
            ? 'Inter, Source Han Sans CN, sans-serif'
            : 'Inter, -apple-system, BlinkMacSystemFont, sans-serif',
        },
      }}
    >
      <App />
    </ConfigProvider>
  )
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AppWrapper />
  </React.StrictMode>,
)

